import { render, staticRenderFns } from "./ClassPreview.vue?vue&type=template&id=e84ffac8&"
import script from "./ClassPreview.vue?vue&type=script&lang=js&"
export * from "./ClassPreview.vue?vue&type=script&lang=js&"
import style0 from "./ClassPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports